import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "app-toggle",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./toggle.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: "./toggle.component.scss",
})
export class ToggleComponent {
  @Input() public label: string;
  @Input() public checked = false;

  @Output() public toggleChange = new EventEmitter<boolean>();

  public onToggleChange(): void {
    this.checked = !this.checked;
    this.toggleChange.emit(this.checked);
  }
}
